import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  sendNotification,
  getStats,
  rowSelect,
  addEvent,
} from '../../store/action/patient.action'
import {
  Row,
  Col,
  Button,
  Modal,
  Card,
  Form,
  Input,
  message,
  DatePicker,
} from 'antd'
import _ from 'lodash'
import '../../css/patient.scss'
import moment from 'moment'

const AddEvent = (props) => {
  var form = useRef(null)

  useEffect(() => {
    var date = props.date ? moment(props.date) : moment()
    form.current && form.current.setFieldsValue({ date })
  }, [props.date])

  var handleCancel = () => {
    form.current && form.current.resetFields()
    props.onClose()
  }

  var handleOk = () => {
    form.current.validateFields().then((values) => {
      console.log(values)
      props.addEvent(
        props.patient._id,
        {
          ...values,
          date: props.date && props.hideDate ? props.date : values.date,
        },
        props.patient
      )
      form.current && form.current.resetFields()
      props.onSuccess()
    })
  }

  var disabledDate = (current) => {
    // Can not select days before today
    return current && current < moment().subtract(1, 'd').endOf('day')
  }

  var renderBody = () => {
    return (
      <Card bordered={false}>
        <Col>
          <Row>
            <Col flex={'auto'}>
              <Form
                ref={form}
                name='normal_login'
                layout={'vertical'}
                initialValues={{ date: moment(props.date) }}
                labelCol={{ span: 3 }}
              >
                <Col>
                  <Form.Item
                    name='date'
                    label='Date'
                    rules={[
                      {
                        required: true,
                        message: 'Please input Title!',
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={props.hideDate}
                      disabledDate={disabledDate}
                    />
                  </Form.Item>
                </Col>
                <Form.Item
                  name='title'
                  label='Title'
                  rules={[
                    {
                      required: true,
                      message: 'Please input Title!',
                    },
                  ]}
                >
                  <Input placeholder='Title' />
                </Form.Item>
                <Form.Item name='message' label='Text'>
                  <Input.TextArea allowClear rows={4} />
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Col>
      </Card>
    )
  }

  return (
    <Modal
      className={'filterModal'}
      visible={props.visible}
      closable={false}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleOk}
      width={'70%'}
      okText={'Send'}
    >
      {renderBody()}
    </Modal>
  )
}

AddEvent.propTypes = {
  customer: PropTypes.object,
  patientid: PropTypes.string,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  visible: PropTypes.bool,
  date: PropTypes.object,
  hideDate: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    patient: state.patient.patient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addEvent: (id, input, state) => dispatch(addEvent(id, input, state)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEvent)
